<template>
    <div>
        <span class="text-dark mr-2">{{name}}: </span>
        <div style="display:inline-block;">
            <span :class="{ 'text-muted' :value}">{{ stateOff }}</span>
            <b-form-checkbox inline :disabled="disabled" v-model=value name="check-button" switch
                             data-on-color="secondary"
                             data-off-color="secondary"
                             v-on="$listeners">
            </b-form-checkbox>
            <span :class="{ 'text-muted' :!value}">{{ stateOn }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TwoStateButton",
        props: ["name", "stateOn", "stateOff", "disabled", "props"],
        data() {
            return {
                value: true
            }
        }
    }
</script>

<style lang="less">
    // More disabled-looking
    .custom-control-input:disabled ~ .custom-control-label::before {
        background-color: gray;
        border-color: darkgray;
    }


    // Check or unchecked does not change look
    .custom-switch {
        .custom-control-label::before {
            color: #fff;
            border-color: #007bff;
            background-color: #007bff;
        }

        .custom-control-label::after {
            background-color: #fff;
        }
    }

    .custom-control.custom-control-inline.custom-switch {
        vertical-align: middle;
        margin-right: 0px;
        margin-left: 4px;
    }

</style>
